import { useCallback, useEffect, useState } from 'react'
import { useAppDispatch } from '../../redux/storeExports'
import { fetchBrokerRecords } from '../../redux/brokerService'
import { IBrokerRecordsParams } from '../../components/shared/atom/inputs/brokerRecordTypes'
import { getAuthenticatedUser, getUserNameFromToken } from '../../services/AuthenticationService'

const useBrokerRecordsFetch = (
  brokerRecordsReqParams: IBrokerRecordsParams,
) => {
    const [isFetching, setIsFetching] = useState(false)
    const appDispatch = useAppDispatch()
    const fetchResults = useCallback(async () => {
    setIsFetching(true)
    const isEmpty = (arr: any[] | null) => !arr || arr.length === 0;
    const originalFilters = brokerRecordsReqParams.filters;

    let newFilters = { ...originalFilters };
      const user = await getAuthenticatedUser();
      const userName = await getUserNameFromToken();

    if (user.userInfo.removalRole === "removal_specialist") {
      if (isEmpty(originalFilters.removal_assignee)) {
        newFilters.removal_assignee = [userName, "N/A"];
      }

      if (isEmpty(originalFilters.removal_group)) {
        newFilters.removal_group = ["removal_specialist", "N/A"];
      }

      if (isEmpty(originalFilters.execution_status_updated_by)) {
        newFilters.execution_status_updated_by = [userName, "N/A"];
      }

      if (isEmpty(originalFilters.status_updated_by)) {
        newFilters.status_updated_by = [userName, "N/A"];
      }
    }

    const replaceNAWithNull = (arr: string[] | null) => {
      if (!arr) return arr;
      if (!arr.includes("N/A")) return arr;

      return [...arr.filter((val) => val !== "N/A"), null];
    };

    newFilters = {
      ...newFilters,
      removal_group: replaceNAWithNull(newFilters.removal_group),
      removal_assignee: replaceNAWithNull(newFilters.removal_assignee),
      execution_status_updated_by: replaceNAWithNull(newFilters.execution_status_updated_by),
      status_updated_by: replaceNAWithNull(newFilters.status_updated_by)
    };

    const newParams = {
      ...brokerRecordsReqParams,
      filters: newFilters,
    };

    await appDispatch(fetchBrokerRecords(newParams));
    setIsFetching(false)
  }, [appDispatch, brokerRecordsReqParams])
  useEffect(() => {
    fetchResults()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    brokerRecordsReqParams.pageSize,
    brokerRecordsReqParams.page,
    brokerRecordsReqParams.sort,
  ])
  return { isFetching, fetchResults }
}
export default useBrokerRecordsFetch